import { ISearchCatalogItemSchema } from '@cian/api-models/monolith-python/cian-api/site/v1/search-regions-cities';
import { TTypedThunkDispatch } from '../../types/thunk';
import { resolveRegionCities } from '../../api/regionCities';
import { setRegionCities } from './setRegionCities';
import { IApplicationState } from '../../types/redux';
import { IApplicationContext } from '../../types/applicationContext';

export function getRegionCities(id: number) {
  return (dispatch: TTypedThunkDispatch, getState: () => IApplicationState, { httpApi }: IApplicationContext) => {
    const subdomain = getState().location.subdomain || 'www';

    return resolveRegionCities(httpApi, id, subdomain).then((regionCitiesData: ISearchCatalogItemSchema[]) => {
      dispatch(setRegionCities(regionCitiesData));
    });
  };
}
